// Strings from backend that it sends as, for example,
// error.response.data = {project_version: ['Error description', 'code_estimate_has_act']}
const ERR_STRINGS = ['code_estimate_has_act'];

// *Important* flag is needed for the Axios interceptors: they will
// handle general error cases.

const parseError = (e, { important = false, returnDetail = false } = {}) => {
  if (e?.response?.status >= 400 && e?.response?.status < 500) {
    const data = e.response.data;
    if (typeof data === 'object') {
      if (data.detail) {
        return returnDetail ? data.detail : null;
      } else {
        const val = Object.values(data)[0] || [];
        if (val?.length) {
          if (important) {
            // If important but no special message – don't alert anything
            if (val.some((err) => ERR_STRINGS.includes(err))) {
              return val.filter((err) => !ERR_STRINGS.includes(err)).join(' ');
            } else {
              return null;
            }
          } else {
            // Promise.resolve();
            return val.filter((err) => !ERR_STRINGS.includes(err)).join(' ');
          }
        }
      }
    }
  }
  return null;
};

export default parseError;
